import { useSelector } from 'react-redux';
import { generateBadgeColor, generateListBadgesData } from '../../../../utils/savUtils';
import './TicketBadges.css';

const TicketBadges = ({ nbrsOfTickets, onBadgeClick }) => {
  const savedFilterForm = useSelector ((state) => state.filter.filter);

  const badges = generateListBadgesData(
    nbrsOfTickets.nbrTicketsTotal,
    nbrsOfTickets.nbrAnnules,
    nbrsOfTickets.nbrClotures,
    nbrsOfTickets.nbrEnAttente,
    nbrsOfTickets.nbrEnCours,
    nbrsOfTickets.nbrNonResolu,
    nbrsOfTickets.nbrResolus,
    nbrsOfTickets.nbrOuverts
  );


  return (
    <div className="ticket-badges-container">
      {badges.map((badge, index) => {
        const { textColor, backgroundColor } = generateBadgeColor(badge.text);
        const isActive = savedFilterForm?.statut?.includes(badge.statut) || (index ==0 && savedFilterForm?.statut?.length === 0);

        return (
          <button
            key={index}
            className="ticket-badge"
            style={{
              backgroundColor,
              color: textColor,
              border: isActive ? `1px solid ${textColor}` : 'none',
            }}
            onClick={() => onBadgeClick?.(badge)}
          >
            <span>{badge.text}</span>
            <span>({badge.number})</span>
          </button>
        );
      })}
    </div>
  );
};

export default TicketBadges;